import * as React from 'react';
import * as classNames from 'classnames';

export interface ButtonProps {
  text: string;
  value?: number;
  selected: boolean;
  onClick: (value) => void;
  children?: React.ReactNode;
}

export function Button(props: ButtonProps) {
  const classes = classNames(
    'bump-split-button__option',
    { 'bump-split-button__option--selected': props.selected },
  );

  return (
    <div
      className={classes}
    >
      <button
        type="button"
        value={props.value}
        onClick={
          () => {
            props.onClick(props.value);
          }
        }
      >
        {props.text}
      </button>
      {props.children}
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/bump/button.tsx